require('lib/browser_required')('lib/marionette_serialize')

const Marionette = require('backbone.marionette')
require('lib/backbone_serialize')

// override Marionette.View.prototype.serializeModel
// to use our model.serialize method
Marionette.View.prototype.serializeModel = function serializeModel() {
    return this.model && this.model.serialize() || {}
}

// override Marionette.View.prototype.serializeCollection to use our
// collection.serialize method
Marionette.View.prototype.serializeCollection = function serializeCollection() {
    return this.collection && this.collection.serialize() || {}
}
